import { crmAttachmentPath } from './content';

// Change image destinations only; text/code containing a file path remains untouched.
export function mapMarkdownImages(
  markdown: string,
  map: (url: string) => string,
) {
  let fenced = false;
  return markdown
    .split('\n')
    .map((line) => {
      if (/^\s*(```|~~~)/.test(line)) {
        fenced = !fenced;
        return line;
      }
      if (fenced || /^( {4}|\t)/.test(line)) return line;
      return line.replace(
        /(!\[(?:\\.|[^\]\\])*\]\()([^\s)]+)(\s+(?:"[^"]*"|'[^']*'))?(\))/g,
        (_match, before, url, title, after) =>
          `${before}${map(url)}${title || ''}${after}`,
      );
    })
    .join('\n');
}
export function markdownFileImages(markdown: string) {
  const paths = new Set<string>();
  mapMarkdownImages(markdown, (url) => {
    if (crmAttachmentPath(url)) paths.add(url);
    return url;
  });
  return [...paths];
}
export function restoreFileReferences(
  markdown: string,
  urls: Map<string, string>,
) {
  // Blob URLs are unique to this editor session, including images pasted by the shared editor.
  for (const [stable, display] of urls)
    if (stable !== display) markdown = markdown.split(display).join(stable);
  return markdown;
}
